"use client";
import { Stack } from "@chakra-ui/react";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text, Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import { OFFERING_CONSTANTS } from "./constants";

const OfferingComp = () => {
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  return (
    <Stack align={"center"} justify={"center"}>
      <Stack width={{ base: "100%", md: "60%" }} gap={6}>
        <Heading variant={HeadingVariant} textAlign={"center"}>
          {OFFERING_CONSTANTS.title}
        </Heading>
        <Text variant={"body1"} fontWeight={600} color="text.100" textAlign={"center"}>
          {OFFERING_CONSTANTS.subTitle}
        </Text>
        <Text
          px={8}
          variant={TextVariant}
          color="text.100"
          textAlign={"center"}
          lineHeight={"30px"}
        >
          {OFFERING_CONSTANTS.text}
        </Text>
      </Stack>
      <Button variant={"ideal"} onClick={() => scrollToElement("contact-us", 120)}>
        {OFFERING_CONSTANTS.btnText}
      </Button>
    </Stack>
  );
};
export default OfferingComp;
